/**
** @ngInject
*/

var sliderWrapper = {
    bindings : {
        size : '@',
        credit : '@'
    },
	controller: function SliderWrapperCtrl($element, $timeout, $scope) {
		var ctrl = this;
		var swiperInitDelay = 0;
        var swiper;
        
		function init() {
        }

        function link() {     
            $timeout(initSwiper, swiperInitDelay);
        }

        function onSlideChangeStart (swiper) {
            var slide = swiper.slides[swiper.activeIndex];
            ctrl.captionStyle = slide.getAttribute('caption-style');
            ctrl.captionText = slide.getAttribute('caption');
            ctrl.photoCredit = slide.getAttribute('photo-credit');
            try {
                $scope.$digest();
            } catch(ex) {

            }
        }

        function initSwiper (swiper) {
            var swiperSettings = {
                nextButton : '.swiper-button-next',
                prevButton : '.swiper-button-prev',
                pagination : '.swiper-pagination',
                paginationType: 'fraction',
                keyboardControl : true,
                loop :  true,
                onSlideChangeStart : onSlideChangeStart
            };
            if(ctrl.size === "bg-cover") {
                swiperSettings.centeredSlides = true;
                swiperSettings.slidesPerView = 'auto';
                
            }
            swiper = new Swiper('.swiper-container', swiperSettings);
        }

		ctrl.$onInit = init;
		ctrl.$postLink = link;
	},
    transclude : true,
	template : [
                '<div class="slider-container" ng-transclude></div>',
                    '<div class="slide-info {{$ctrl.captionStyle}}">',
                        '<div class="caption-container">',
                            '<div class="swiper-pagination"></div>',
                            '<p class="caption">{{$ctrl.captionText}}</p>',
                            '<div class="photo-credit" ng-if="$ctrl.photoCredit">',
                                '<span class="foto"> {{$ctrl.credit}}: </span>',
                                '<span class="creditor">{{$ctrl.photoCredit}}</span>',
                            '</div>',
                        '</div>',
                    '</div>',
                '</div>'
    ].join('')
};